export default __webpack_public_path__ + "static/media/MGL.9a409ff9.svg";